import { base } from './';
import { IContent, SearchContentsQueryType } from 'types';

const PATH = '/contents';

const get = (id: string) => base.get(`${PATH}/${id}`);

const getAll = (filter: SearchContentsQueryType) =>
  base.get(PATH, { params: { ...filter } });

const post = (data: Partial<IContent>) => base.post(PATH, data);

const patch = ({ id, ...data }: Partial<IContent & { isNewFile: boolean }>) =>
  base.patch(`${PATH}/${id}`, data);

const getJSON = (id: string) =>
  base.get(`${PATH}/${id}/json`, {
    params: { isDev: process.env.REACT_APP_ENV === 'dev' },
  });

export { get, getAll, post, patch, getJSON };
